/*
 * Copyright (c) 2020. Dave van Rijn Development
 */

import {ErrorType, ThemeShape} from '@dvrd/dvr-controls';

import User from '../models/userModel';
import Vehicle from '../models/vehicleModel';

export interface UserContext {
    user: User | null,
}

export interface VehicleContext {
    vehicles: Array<Vehicle>;
    vehicle: Vehicle | null;
}

export interface ContextShape {
    userContext: UserContext,
    vehicleContext: VehicleContext;
    theme: ThemeShape,
    onChangeContext: (config: ChangeContextConfig, callback?: VoidFunction) => void;
}

export interface ActivateHandle<T = any> {
    activate: (params?: T, ...otherParams: any) => void;
}

//===========================
// TYPES
//===========================
export type ChangeContextConfig = { user?: User | null; vehicles?: Array<Vehicle>; vehicle?: Vehicle | null };

export type DistanceErrors = {
    start_km: ErrorType;
    end_km: ErrorType;
    date: ErrorType;
}

export type DistanceInfo = {
    [DistancePurpose.PRIVATE]: number;
    [DistancePurpose.BUSINESS]: number;
}

export type VehicleErrors = {
    label: ErrorType; licence_number: ErrorType;
}

//===========================
// ENUMS
//===========================
export enum UserType {
    ADMIN = 'admin', USER = 'user',
}

export enum EditMode {
    NEW, EDIT
}

export enum UserStatus {ACTIVE = 'active', INVITED = 'invited', DELETED = 'deleted', REGISTERED = 'registered'}

export enum DistancePurpose {PRIVATE = 'PRIVATE', BUSINESS = 'BUSINESS'}

export enum VehicleType {CAR = 'CAR', MOTOR = 'MOTOR', VAN = 'VAN'}